var widget_default = {
  "card": "zM3Tp",
  "link": "_9B6TL",
  "container": "_2G6YP",
  "image": "p1Xbq",
  "right": "P0sGB",
  "cardLayout": "iXS9w",
  "content": "_3uAF-",
  "title": "_5EgU4",
  "subtitle": "anBH6",
  "button": "pBEDG",
  "button_disabled": "qyItX",
  "buttonText": "TyvP7",
  "slimLayout": "_9aI-d",
  "contentText": "hlG5A"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
